// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"aaf1809d","354":"0f43e4d4","838":"e53f8e64"}[chunkId] + ".js";
};